var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 340.00 340.00",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.0034000000000000002,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 5.4399999999999995
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2186_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2187_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2188_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2189_",
    style: {
      fill: "#595959"
    },
    d: "M170,134.134c3.547,0,6.927,0.72,10,2.021V13.134h-20v123.021 C163.073,134.854,166.453,134.134,170,134.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2190_",
    style: {
      fill: "#595959"
    },
    d: "M170,185.467c-3.547,0-6.927-0.72-10-2.021v85.688h20v-85.688 C176.927,184.747,173.547,185.467,170,185.467z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2191_",
    style: {
      fill: "#595959"
    },
    d: "M170,195.467c-19.667,0-35.667-16-35.667-35.666 c0-19.667,16-35.667,35.667-35.667s35.667,16,35.667,35.667C205.667,179.467,189.667,195.467,170,195.467z M170,144.134 c-8.639,0-15.667,7.028-15.667,15.667s7.028,15.666,15.667,15.666s15.667-7.027,15.667-15.666S178.639,144.134,170,144.134z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2194_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2195_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2196_",
    style: {
      fill: "#595959"
    },
    d: "M65.5,134.134c3.547,0,6.927,0.72,10,2.021V13.134h-20v123.021 C58.573,134.854,61.953,134.134,65.5,134.134z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2197_",
    style: {
      fill: "#595959"
    },
    d: "M65.5,185.467c-3.547,0-6.927-0.72-10-2.021v85.688h20v-85.688 C72.427,184.747,69.047,185.467,65.5,185.467z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2198_",
    style: {
      fill: "#595959"
    },
    d: "M65.5,195.467c-19.667,0-35.667-16-35.667-35.666 c0-19.667,16-35.667,35.667-35.667s35.667,16,35.667,35.667C101.167,179.467,85.167,195.467,65.5,195.467z M65.5,144.134 c-8.639,0-15.667,7.028-15.667,15.667s7.028,15.666,15.667,15.666s15.667-7.027,15.667-15.666S74.139,144.134,65.5,144.134z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2201_",
    style: {
      fill: "#595959"
    },
    d: "M313.134,326.866H26.866C12.052,326.866,0,314.814,0,300v-18 c0-14.814,12.052-26.866,26.866-26.866h286.268C327.948,255.134,340,267.186,340,282v18 C340,314.814,327.948,326.866,313.134,326.866z M26.866,275.134c-3.786,0-6.866,3.08-6.866,6.866v18 c0,3.786,3.08,6.866,6.866,6.866h286.268c3.786,0,6.866-3.08,6.866-6.866v-18c0-3.786-3.08-6.866-6.866-6.866H26.866z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2204_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2205_",
    style: {
      fill: "#59595900969B"
    },
    cx: 65.5,
    cy: 95.134,
    r: 25.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2206_",
    style: {
      fill: "#595959"
    },
    d: "M65.5,130.801c-19.667,0-35.667-16-35.667-35.667s16-35.667,35.667-35.667 s35.667,16,35.667,35.667S85.167,130.801,65.5,130.801z M65.5,79.467c-8.639,0-15.667,7.028-15.667,15.667 s7.028,15.667,15.667,15.667s15.667-7.028,15.667-15.667S74.139,79.467,65.5,79.467z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2209_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2210_",
    style: {
      fill: "#59595900969B"
    },
    cx: 65.5,
    cy: 224.467,
    r: 25.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2211_",
    style: {
      fill: "#595959"
    },
    d: "M65.5,260.134c-19.667,0-35.667-16-35.667-35.667 c0-19.666,16-35.666,35.667-35.666s35.667,16,35.667,35.666C101.167,244.134,85.167,260.134,65.5,260.134z M65.5,208.801 c-8.639,0-15.667,7.027-15.667,15.666s7.028,15.667,15.667,15.667s15.667-7.028,15.667-15.667S74.139,208.801,65.5,208.801z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2214_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2215_",
    style: {
      fill: "#59595900969B"
    },
    cx: 170,
    cy: 224.467,
    r: 25.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2216_",
    style: {
      fill: "#595959"
    },
    d: "M170,260.134c-19.667,0-35.667-16-35.667-35.667 c0-19.666,16-35.666,35.667-35.666s35.667,16,35.667,35.666C205.667,244.134,189.667,260.134,170,260.134z M170,208.801 c-8.639,0-15.667,7.027-15.667,15.666s7.028,15.667,15.667,15.667s15.667-7.028,15.667-15.667S178.639,208.801,170,208.801z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2219_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2220_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2221_",
    x: 264.5,
    y: 13.134,
    style: {
      fill: "#595959"
    },
    width: 20,
    height: 256
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2222_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2223_",
    style: {
      fill: "#59595900969B"
    },
    cx: 274.5,
    cy: 224.467,
    r: 25.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2224_",
    style: {
      fill: "#595959"
    },
    d: "M274.5,260.134c-19.667,0-35.667-16-35.667-35.667 c0-19.666,16-35.666,35.667-35.666s35.667,16,35.667,35.666C310.167,244.134,294.167,260.134,274.5,260.134z M274.5,208.801 c-8.639,0-15.667,7.027-15.667,15.666s7.028,15.667,15.667,15.667s15.667-7.028,15.667-15.667S283.139,208.801,274.5,208.801z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountIcon);
export default __webpack_public_path__ + "static/media/count-icon.3dbceab4db64cee2d6f42fb309c9c4c9.svg";
export { ForwardRef as ReactComponent };